import type * as React from "react";
import { cn } from "../utils";

function Textarea({ className, ...props }: React.ComponentPropsWithRef<"textarea">) {
  return (
    <textarea
      className={cn(
        `
          flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2.5 text-sm 
          ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
          placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 read-only:bg-accent read-only:text-muted-foreground
        `,
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
